import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { FiMaximize } from 'react-icons/fi'; // иконка открытия
import 'swiper/css';
import 'swiper/css/navigation';
import style from './gallery.module.css';

const Gallery = ({ item }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const images = Object.entries(item)
    .filter(([key, val]) => key.startsWith('img') && val)
    .map(([_, val]) => val);

  const openModal = (index = 0) => {
    setActiveIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  useEffect(() => {
    document.body.style.overflow = modalOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [modalOpen]);

  if (images.length === 0) return null;

  return (
    <>
      <div className={style.top}>
        <div className={style.galleryWrapper}>
          {/* Кнопка-иконка */}
          <button className={style.iconButton} onClick={() => openModal()}>
            <FiMaximize size={28} />
          </button>

          <Swiper
            loop
            spaceBetween={10}
            navigation
            modules={[Navigation]}
            slidesPerView={1.2}
            grabCursor
            className={style.imgSlider}
          >
            {images.map((src, index) => (
              <SwiperSlide key={index}>
                <img
                  src={`../imgs/playground/${src}`}
                  alt={`Галерея ${index + 1}`}
                  className={style.image}
                  loading="lazy"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {modalOpen && (
        <div className={style.modalOverlay} onClick={closeModal}>
          <div
            className={style.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <button className={style.closeButton} onClick={closeModal}>
              &times;
            </button>
            <Swiper
              initialSlide={activeIndex}
              loop
              navigation
              modules={[Navigation]}
              className={style.modalSwiper}
            >
              {images.map((src, index) => (
                <SwiperSlide key={index} className={style.mod_img}>
                  <img
                    src={`../imgs/playground/${src}`}
                    alt={`Фото ${index + 1}`}
                    className={style.modalImage}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
